import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOJsonLd from '../../components/feature/SEOJsonLd';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import ClientsSection from './components/ClientsSection';
import ClientPortalSection from './components/ClientPortalSection';
import ConsultationSection from './components/ConsultationSection';
import ContactSection from './components/ContactSection';
import SystemStatusSection from './components/SystemStatusSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <SEOJsonLd />
      <Header />
      <main>
        <HeroSection />
        <SystemStatusSection />
        {/* Need Immediate Assistance Section */}
        <section className="py-8 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-red-50 border border-red-200 rounded-xl shadow-lg p-8 text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Need Immediate Assistance?</h3>
              <p className="text-gray-600 mb-6">Our support team is available 24/7 to help with urgent issues</p>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex items-center justify-center">
                  <i className="ri-phone-line text-red-600 mr-3 text-xl"></i>
                  <div>
                    <div className="font-semibold text-gray-900">Emergency Hotline</div>
                    <div className="text-red-600 font-bold">(804) 613-6131</div>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <i className="ri-message-3-line text-red-600 mr-3 text-xl"></i>
                  <div>
                    <div className="font-semibold text-gray-900">Text for Support</div>
                    <div className="text-red-600 font-bold">(804) 613-6131</div>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <i className="ri-time-line text-red-600 mr-3 text-xl"></i>
                  <div>
                    <div className="font-semibold text-gray-900">Response Time</div>
                    <div className="text-red-600 font-bold">&lt; 2 hours</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ServicesSection />
        <AboutSection />
        <ClientsSection />
        <ClientPortalSection />
        <ConsultationSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
